import { render, staticRenderFns } from "./TheModalTratamientoEnCurso.vue?vue&type=template&id=36eb97a5&scoped=true&"
import script from "./TheModalTratamientoEnCurso.vue?vue&type=script&lang=js&"
export * from "./TheModalTratamientoEnCurso.vue?vue&type=script&lang=js&"
import style0 from "./TheModalTratamientoEnCurso.vue?vue&type=style&index=0&id=36eb97a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb97a5",
  null
  
)

export default component.exports